import { Fragment, type ReactNode } from 'react'
import { MARK_CLASS } from '../palette'
import { wordsPattern } from '../highlight'

/** Plain text with the search words wrapped in <mark>. React escapes the text; no HTML involved. */
export function Highlight({ text, words }: { text: string | null | undefined; words: readonly string[] }): ReactNode {
    const value = text ?? ''
    const re = wordsPattern(words)
    if (!re || !value) return value
    const parts = value.split(re)
    return parts.map((part, i) =>
        i % 2 === 1 ? (
            <mark key={i} className={MARK_CLASS}>
                {part}
            </mark>
        ) : (
            <Fragment key={i}>{part}</Fragment>
        ),
    )
}
